import ImageValidateMixin from './imageValidate.mixin'

export {
  ImageValidateMixin
}